import {required} from "vuelidate/lib/validators";
import {TicketType} from "@share/ticketSystem/enums/TicketTypes";

const getValidationObject = (isAdmin: boolean, type: string | null, hasBigEffect: boolean):
{ ticket: Record<string, any> } => {
  const ticketValidator = {
        ticket: {
              title: {
                  required
              },
              description: {
                  required
              },
              category: {
                  required
              }
        }
  };

  if (isAdmin) {
      Object.assign(ticketValidator.ticket, {
              ownerId: {
                  required
              },
              responsibleUserId: {
                  required
              },
              status: {
                  required
              }
          }
      )
  }

  if (type === TicketType.idea) {
      Object.assign(ticketValidator.ticket, {
              solution: {
                  required
              }
          }
      )
  } else {
      Object.assign(ticketValidator.ticket, {
              riskLocation: {
                  required
              },
              riskLevel: {
                  required
              }
          }
      )
  }

  if (hasBigEffect) {
      Object.assign(ticketValidator.ticket, {
              effectFormation: {
                  required
              }
          }
      )
  }

  return ticketValidator;
}

export default getValidationObject;
